export default {"src":"/_next/static/media/radinfra-logo.4dbf251a.svg","height":379,"width":296,"blurWidth":0,"blurHeight":0};